module.exports = __webpack_public_path__ + "img/jump-rope.22778963.jpg";